export default function(inputRut, pais) {
    console.log("=======> Validando pais - inputRut: "+ pais + " - " + inputRut);
    if(!pais || pais === 'CHL')
      return validaChile(inputRut);
    
    return true;
}


function validaChile( inputRut ){
  if(!inputRut)
      return false
    inputRut = inputRut.replaceAll('-', '')
    inputRut = inputRut.replaceAll('\.', '')
    //console.log('=======> Validare rut2: '+ inputRut);
    let cuerpo = inputRut.slice(0, -1)
    let dv = inputRut.slice(-1).toUpperCase()
    if (cuerpo.length < 7) {
      //console.log('=======> rutLength ');
      return false
    }
    let suma = 0
    let multiplo = 2
    for (let i = 1; i <= cuerpo.length; i++) {
      let index = multiplo * inputRut.charAt(cuerpo.length - i)
      suma = suma + index
      if (multiplo < 7) {
        multiplo = multiplo + 1
      } else {
        multiplo = 2
      }
    }
    
    let dvEsperado = 11 - suma % 11
    //console.log("dvEsperado: ", dvEsperado);

    dv = dv === 'K' ? 10 : dv
    dv = dv === '0' ? 11 : dv

    //console.log("Comparando con " , dv);
    if (String(dvEsperado) !== String(dv)) {
      //console.log("String(dvEsperado):"  + String(dvEsperado));
      return false
    }
    return true
}


// WEBPACK FOOTER //
// ./src/App/helpers/validations/rutValidation.js